import type { UiTranslations } from '../types.js'

export const ui: UiTranslations = {}
